export const initialState = {};

const purchaseReducer = (state = initialState, action) => {
  switch (action.type) {
    // case

    default:
      return state;
  }
}

export default purchaseReducer;
